import SearchChoicesList from './SearchChoicesList';

export default SearchChoicesList;
